
const DefaultLocationPhoto = 'https://static.bodyspec.com/at/95/f7/95f7c39f758dded1';
const DefaultVanPhoto = 'https://static.bodyspec.com/at/bf/8d/bf8dd1f301933724';
const DefaultVanPhotoAlt = 'https://static.bodyspec.com/at/8d/8f/8d8f00b83452ce9c';

export const usePhotos = (urls?: string[]): string[] => {
	if (!urls || !urls.length) {
		return [
			DefaultLocationPhoto,
			DefaultVanPhoto,
			DefaultVanPhotoAlt,
		];
	}

	const copy = [...urls];
	if (copy.length < 3) {
		copy.push(DefaultVanPhoto);

		if (copy.length < 3) {
			copy.push(DefaultVanPhotoAlt);
		}
	}

	return copy;
};
